import { render, staticRenderFns } from "./CategoryCard.vue?vue&type=template&id=573535f6&scoped=true&"
import script from "./CategoryCard.vue?vue&type=script&lang=js&"
export * from "./CategoryCard.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCard.vue?vue&type=style&index=0&id=573535f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573535f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('573535f6')) {
      api.createRecord('573535f6', component.options)
    } else {
      api.reload('573535f6', component.options)
    }
    module.hot.accept("./CategoryCard.vue?vue&type=template&id=573535f6&scoped=true&", function () {
      api.rerender('573535f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/cards/CategoryCard.vue"
export default component.exports